module.exports = __webpack_public_path__ + "images/demo-avatar9604.jpg";